export const VERSION_INFO = { tag: 'v1.57.2', branch: 'v1.57.2', commit: '610796a7b37bdf783505c95cb1aa6200be4a314b' }
